import { CORTES_EJE_X, CORTES_EJE_Y, MATRIZ_CSS } from '../tipologia';
import { txt } from '../i18n';
import './matriz.css';

// Reproduce la leyenda del panel A: matriz 3x3 de accesibilidad retenida (eje
// vertical) contra peso de la poblacion trabajadora (eje horizontal), con los
// colores de la figura. Resalta la casilla donde cae la celda elegida;
// accClass y pesoClass son sus clases (0,1,2), y pueden venir sin definir
// cuando la matriz se usa como leyenda del mapa y no hay celda elegida.
//
// tamano "compacta" va en el panel de la celda; "grande" en la leyenda del
// mapa, donde ademas se rotulan los cortes de los dos ejes.
export default function MatrizTipologia({ accClass, pesoClass, tamano = 'compacta' }) {
  // MATRIZ_COLORES esta indexada [accClass][pesoClass] con fila 0 = acc baja;
  // para dibujar de arriba (acc alta) hacia abajo, se recorre en reverso.
  const filas = [2, 1, 0];
  const grande = tamano === 'grande';
  return (
    <div className={`matriz-tip matriz-tip--${tamano}`}>
      <span className="matriz-eje-y">{txt('matriz.ejeY')}</span>
      {grande && (
        <div className="matriz-cortes-y">
          {[...CORTES_EJE_Y].reverse().map((corte) => (
            <span key={corte}>{corte}</span>
          ))}
        </div>
      )}
      <div className="matriz-grilla">
        {filas.map((acc) =>
          [0, 1, 2].map((peso) => {
            const activa = acc === accClass && peso === pesoClass;
            return (
              <div
                key={`${acc}-${peso}`}
                className={`matriz-celda ${activa ? 'matriz-celda--activa' : ''}`}
                style={{ background: MATRIZ_CSS[acc][peso] }}
              />
            );
          })
        )}
      </div>
      {grande && (
        <div className="matriz-cortes-x">
          {CORTES_EJE_X.map((corte) => (
            <span key={corte}>{corte}</span>
          ))}
        </div>
      )}
      <span className="matriz-eje-x">{txt('matriz.ejeX')}</span>
    </div>
  );
}
